var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgSushi = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M28.3333 26.6667C32.9357 26.6667 36.6667 24.4281 36.6667 21.6667C36.6667 18.9052 32.9357 16.6667 28.3333 16.6667C23.731 16.6667 20 18.9052 20 21.6667C20 24.4281 23.731 26.6667 28.3333 26.6667Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M20.0001 16.6667C24.6025 16.6667 28.3334 14.4281 28.3334 11.6667C28.3334 8.90523 24.6025 6.66666 20.0001 6.66666C15.3977 6.66666 11.6667 8.90523 11.6667 11.6667C11.6667 14.4281 15.3977 16.6667 20.0001 16.6667Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M11.6666 26.6667C16.269 26.6667 19.9999 24.4281 19.9999 21.6667C19.9999 18.9052 16.269 16.6667 11.6666 16.6667C7.06421 16.6667 3.33325 18.9052 3.33325 21.6667C3.33325 24.4281 7.06421 26.6667 11.6666 26.6667Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6666 26.6667C7.06492 26.6667 3.33325 24.4283 3.33325 21.6667V28.3333C3.33325 31.095 7.06492 33.3333 11.6666 33.3333C16.2683 33.3333 19.9999 31.095 19.9999 28.3333V21.6667C19.9999 24.4283 16.2683 26.6667 11.6666 26.6667Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3333 26.6667C23.7317 26.6667 20 24.4283 20 21.6667V28.3333C20 31.095 23.7317 33.3333 28.3333 33.3333C32.935 33.3333 36.6667 31.095 36.6667 28.3333V21.6667C36.6667 24.4283 32.935 26.6667 28.3333 26.6667Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0001 21.6667C20.0001 18.905 23.7317 16.6667 28.3334 16.6667V11.6667C28.3334 14.4283 24.6017 16.6667 20.0001 16.6667C15.3984 16.6667 11.6667 14.4283 11.6667 11.6667V16.6667C16.2684 16.6667 20.0001 18.905 20.0001 21.6667Z",
    fill: "currentColor"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0001 13.3333C21.841 13.3333 23.3334 12.5871 23.3334 11.6667C23.3334 10.7462 21.841 10 20.0001 10C18.1591 10 16.6667 10.7462 16.6667 11.6667C16.6667 12.5871 18.1591 13.3333 20.0001 13.3333Z",
    fill: "currentColor"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6666 23.3333C13.5075 23.3333 14.9999 22.5871 14.9999 21.6667C14.9999 20.7462 13.5075 20 11.6666 20C9.82564 20 8.33325 20.7462 8.33325 21.6667C8.33325 22.5871 9.82564 23.3333 11.6666 23.3333Z",
    fill: "currentColor"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3333 23.3333C30.1743 23.3333 31.6667 22.5871 31.6667 21.6667C31.6667 20.7462 30.1743 20 28.3333 20C26.4924 20 25 20.7462 25 21.6667C25 22.5871 26.4924 23.3333 28.3333 23.3333Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSushi, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/sushi.11b3ad32.svg";
export { ForwardRef as ReactComponent };